import React, { memo } from "react";
import { createPortal } from "react-dom";
import "./CallModal.css";
import { resolveImage } from "../../Utils/imageUtils";

function CallModal({ partners, close }) {
  return createPortal(
    <div className="call-overlay" role="dialog" aria-modal="true" aria-label="Contact Carsinfinite">
      <div className="call-backdrop" aria-hidden="true" onClick={close} />
      <div className="call-container" onClick={(e) => e.stopPropagation()}>
        <div className="call-sheet-handle" aria-hidden="true" />
        <div className="call-header">
          <h3>Contact Carsinfinite</h3>
          <button type="button" className="close-btn" onClick={close} aria-label="Close">
            ✖
          </button>
        </div>

        <div className="call-body">
          {partners.length === 0 ? (
            <p className="no-partner">No partner available</p>
          ) : (
            <div className="partner-list">
              {partners.map((partner) => (
                <div key={partner.id} className="partner-card">
                  <div className="partner-info">
                    <div className="partner-avatar">
                      {partner.profile_image && !partner.profile_image.includes("placehold") ? (
                        <img
                          src={resolveImage(partner.profile_image)}
                          alt={partner.name}
                          className="avatar-img"
                        />
                      ) : (
                        partner.name.charAt(0).toUpperCase()
                      )}
                    </div>
                    <div>
                      <h4>
                        {partner.name}
                        {partner.isAdminFallback ? " (Admin)" : ""}
                      </h4>
                      <p>{partner.ph_num}</p>
                    </div>
                  </div>

                  <div className="partner-actions">
                    <a href={`tel:${partner.ph_num}`} className="call-btn">
                      📞 Call
                    </a>
                    <a
                      href={`https://wa.me/91${partner.ph_num}`}
                      target="_blank"
                      rel="noreferrer"
                      className="whatsapp-btn"
                    >
                      💬 WhatsApp
                    </a>
                  </div>
                </div>
              ))}
            </div>
          )}
        </div>
      </div>
    </div>,
    document.body
  );
}

export default memo(CallModal);
